import { Box, Grid, Typography } from '@mui/material';

const SectionBlock = ({ title, children, sx }) => (
  <Box
    sx={{
      backgroundColor: '#f7f8fa',
      borderRadius: 2,
      p: 2,
      mb: 2,
      ...sx
    }}
  >
    <Typography
      variant="overline"
      sx={{
        display: 'block',
        color: 'text.secondary',
        fontWeight: 700,
        letterSpacing: 0.75,
        lineHeight: 1.2,
        mb: 1
      }}
    >
      {title}
    </Typography>
    <Grid container spacing={1.5}>
      {children}
    </Grid>
  </Box>
);

export default SectionBlock;
